import React, { useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import MenuItem from "@mui/material/MenuItem";
import getPropBySearchProp from "../../../../../functions/getPropBySearchProp";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB";
import getNestedPropBySearchProp from "../../../../../functions/getNestedPropBySearchProp";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort";
import SearchAgenciesSetECs from "../../../../components/Search/SearchAgenciesSetECs";
import { Get_One_From_MongoDB } from "../../../../api/Get_One_From_MongoDB";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function IP({ Attendee, setAttendee, Staff }) {
  const { logout } = StaffuseAuth();

  const handleIPInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      IPInfo: { ...Attendee.IPInfo, [e.target.name]: e.target.value },
    });
  };

  return (
    <section>
      <h2>IP Info</h2>
      <Grid container spacing={2}>
        <SearchAgenciesSetECs
          handleChoose={handleIPInfoChange}
          Attendee={Attendee}
        />
        <Grid item xs={4}>
          {Attendee.IPInfo && Attendee.IPInfo["uncleanInfo"] ? (
            <TextField
              key="uncleanInfo"
              name="uncleanInfo"
              label="uncleanInfo"
              variant="outlined"
              margin="normal"
              fullWidth
              value={
                Attendee.IPInfo && Attendee.IPInfo["uncleanInfo"]
                  ? Attendee.IPInfo["uncleanInfo"]
                  : ""
              }
              onChange={handleIPInfoChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                },
              }}
            />
          ) : (
            <></>
          )}
          {Attendee.IPInfo && Attendee.IPInfo["uncleanCountry"] ? (
            <TextField
              key="uncleanCountry"
              name="uncleanCountry"
              label="uncleanCountry"
              variant="outlined"
              margin="normal"
              fullWidth
              value={
                Attendee.IPInfo && Attendee.IPInfo["uncleanCountry"]
                  ? Attendee.IPInfo["uncleanCountry"]
                  : ""
              }
              onChange={handleIPInfoChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                },
              }}
            />
          ) : (
            <></>
          )}
          {Attendee.IPInfo && Attendee.IPInfo["uncleanCity"] ? (
            <TextField
              key="uncleanCity"
              name="uncleanCity"
              label="uncleanCity"
              variant="outlined"
              margin="normal"
              fullWidth
              value={
                Attendee.IPInfo && Attendee.IPInfo["uncleanCity"]
                  ? Attendee.IPInfo["uncleanCity"]
                  : ""
              }
              onChange={handleIPInfoChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                },
              }}
            />
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={4}>
          <TextField
            key="Consent_For_EC_To_See_Data"
            name="EC_Consent"
            label="EC_Consent"
            variant="outlined"
            margin="normal"
            fullWidth
            value={
              Attendee.IPInfo && Attendee.IPInfo["Consent_For_EC_To_See_Data"]
                ? Attendee.IPInfo["Consent_For_EC_To_See_Data"]
                : ""
            }
            onChange={handleIPInfoChange}
            InputProps={{
              style: {
                backgroundColor: "white",
              },
            }}
            select
          >
            <MenuItem key={""} value={""}></MenuItem>
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </TextField>
        </Grid>
      </Grid>
    </section>
  );
}

export default IP;
